import React from "react";
import { Popup } from "semantic-ui-react";
import { BsInfoCircle } from "react-icons/bs";
import { spacing } from "./theme";

const tooltipWrapperStyle = {
  display: "flex",
  gap: spacing.xs,
  alignItems: "center",
};

const tooltipStyle = {
  cursor: "pointer"
};

export default function ContentWithTooltip({ content, popupText, position = "top" }) {
  return (
    <div style={tooltipWrapperStyle}>
      {content}

      <Popup
        content={popupText}
        position={position}
        trigger={
          <BsInfoCircle size={15} style={tooltipStyle} />
        }
      />
    </div>
  );
}